export default "__VITE_ASSET__Dr3HKOCA__"